export enum Option {
  First = "first",
  Second = "second",
  Third = "third",
  Fourth = "fourth",
  Fifth = "fifth",
  Sixth = "sixth",
  Seventh = "seventh",
  FirstAlt = "first-alt",
  SecondAlt = "second-alt",
  ThirdAlt = "third-alt",
  FourthAlt = "fourth-alt",
  FifthAlt = "fifth-alt",
  SixthAlt = "sixth-alt",
  SeventhAlt = "seventh-alt",
}

export function optionToIndex(option: Option): number {
  switch (option) {
    case Option.First:
      return 0;
    case Option.Second:
      return 1;
    case Option.Third:
      return 2;
    case Option.Fourth:
      return 3;
    case Option.Fifth:
      return 4;
    case Option.Sixth:
      return 5;
    case Option.Seventh:
      return 6;
    case Option.FirstAlt:
      return 7;
    case Option.SecondAlt:
      return 8;
    case Option.ThirdAlt:
      return 9;
    case Option.FourthAlt:
      return 10;
    case Option.FifthAlt:
      return 11;
    case Option.SixthAlt:
      return 12;
    case Option.SeventhAlt:
      return 13;
  }
}

export function indexToOption(index: number): Option {
  const map = [
    Option.First,
    Option.Second,
    Option.Third,
    Option.Fourth,
    Option.Fifth,
    Option.Sixth,
    Option.Seventh,
    Option.FirstAlt,
    Option.SecondAlt,
    Option.ThirdAlt,
    Option.FourthAlt,
    Option.FifthAlt,
    Option.SixthAlt,
    Option.SeventhAlt,
  ];

  return map[index];
}
